import { render, staticRenderFns } from "./deptDocumentList.vue?vue&type=template&id=7ed3f477&scoped=true&"
import script from "./deptDocumentList.vue?vue&type=script&lang=js&"
export * from "./deptDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./deptDocumentList.vue?vue&type=style&index=0&id=7ed3f477&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed3f477",
  null
  
)

export default component.exports